import { cn } from '@shared/utils/utils';
import { MasterData } from '@shared/types/publication';

interface CategoryFilterProps {
    categories: MasterData[],
    selectedCategory: string,
    onCategoryChange: (categoryId: string) => void
}

const CategoryFilter = ({
    categories,
    selectedCategory,
    onCategoryChange
}: CategoryFilterProps) => {
    return (
        <div className='flex md:grid md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 gap-[10px] -mx-4 md:mx-0 md:rounded-[10px] p-[10px] bg-[#F6F6F6] mb-6 md:mb-[30px] overflow-x-auto scrollbar-hide'>
            {categories.map(category => (
                <button
                    key={category.id}
                    onClick={() => onCategoryChange(category.code)}
                    className={cn(
                        'flex-shrink-0 px-4 md:px-0 py-[10px] rounded-[10px] font-normal text-sm leading-[26px] transition-all duration-200 whitespace-nowrap',
                        selectedCategory === category.code ?
                            'bg-primary text-white' :
                            'bg-white hover:bg-primary hover:text-white'
                    )}
                >
                    {category.label}
                </button>
            ))}
        </div>
    );
};

export default CategoryFilter;
